import { Injectable } from "@angular/core";
import { ApiNameList } from "src/environments/api-name-list";
import { HttpClientService } from "./http-client-service";

@Injectable()
export class TokenService {
    public baseUrl = '';
    constructor(public httpClientService: HttpClientService) {
        this.baseUrl = ApiNameList.restApi.baseUrl;
    }

    refreshToken() {
        return this.httpClientService.get(this.baseUrl + ApiNameList.restApi.refreshToken).toPromise();
    }
    logout() {
        return this.httpClientService.get(this.baseUrl + ApiNameList.restApi.logout);
    }

}